export default __webpack_public_path__ + "assets/aor-soccer.png";